import axios from 'axios';

const axiosInstance = axios.create({

  baseURL: 'https://backend-nquu.onrender.com', //'http://localhost:5050' ,  //, Change this to your API base URL

  withCredentials: true, // Include credentials in requests 
  //process.env.REACT_APP_BASE_URL ||
}); 

export default axiosInstance;
 
// import axios from 'axios';

// // Create an Axios instance
// const axiosInstance = axios.create({
//   baseURL: 'http://localhost:5050',
//   withCredentials: true, // Include credentials in requests
// });
// export default axiosInstance;

// Response interceptor to handle token expiration and refresh
// axiosInstance.interceptors.response.use(
//   (response) => response, // Pass through successful responses
//   async (error) => {
//     const originalRequest = error.config;

//     // Check if error is due to expired access token and prevent infinite loop
//     if (error.response.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true; // Mark request as retried

//       try {
//         // Attempt to refresh the access token by calling the refresh token endpoint
//         const { data } = await axiosInstance.post('/auth/refresh-token');

//         // Update authorization header with the new access token
//         axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`;

//         // Retry original request with the new access token
//         return axiosInstance(originalRequest);
//       } catch (refreshError) {
//         console.error('Token refresh failed:', refreshError);

//         // If refresh token is also expired or invalid, handle it
//         if (refreshError.response && ( refreshError.response.data.message === "Refresh token not found")) {
//           // Clear local storage, cookies, or any session-related data here
//           // Redirect to login page
//           window.location.href = '/login'; // Redirect to login page or show a message
//         }
//       }
//     }

//     // Reject other errors
//     return Promise.reject(error);
//   }
// );



